import { render, staticRenderFns } from "./TuEstadoCuentaForm.vue?vue&type=template&id=879774ce&scoped=true"
import script from "./TuEstadoCuentaForm.vue?vue&type=script&lang=ts"
export * from "./TuEstadoCuentaForm.vue?vue&type=script&lang=ts"
import style0 from "./TuEstadoCuentaForm.vue?vue&type=style&index=0&id=879774ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879774ce",
  null
  
)

export default component.exports